import { render } from "./pairing-index.vue?vue&type=template&id=68bcd2d9&lang=pug"
import script from "./pairing-index.vue?vue&type=script&lang=js"
export * from "./pairing-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__